import http from 'plugins/axios';
import moment from 'moment';

export default {
  getShareSummary(shareTime) {
    return http.get({
      url: '/la/admin/miningShare/miningShareGeneral',
      data: {
        shareTime: moment(shareTime).valueOf()
      }
    });
  }
};
